import styled from 'styled-components';

const blue = '#003876';

let medium = '55px';

const Avatar = styled.div`
  min-height: ${(props) => props.size ?? `${medium}`};
  min-width: ${(props) => props.size ?? `${medium}`};
  border: ${(props) =>
    props.borderColor && props.size ? '1px solid' : '2px solid'};
  border-color: ${(props) => props.color ?? `${blue}`};
  border-radius: 7px;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: ${(props) => props.textSize};
  letter-spacing: 1px;
  color: ${(props) => props.color ?? `${blue}`};
  transition: all 0.2s ease;

  user-select: none;
  &:hover {
    cursor: pointer;
  }
`;

export { Avatar };
